<template>
  <div class="container mt-4">
    <h2>{{ newsDetail.judul }}</h2>
    <!-- <img
      :src="newsDetail.image"
      alt="news image"
      class="img-fluid rounded mb-3"
    /> -->
    <p>{{ newsDetail.isi }}</p>
    <iframe :src="`https://mui-kendal.or.id/pengurus/assets/files/upload/pdf/${newsDetail.image0}`" width="100%" height="500px"></iframe>
    <!-- <img :src="`https://mui-kendal.or.id/pengurus/assets/files/upload/berita/${news.image}`" alt="news image" class="img-fluid rounded"> -->
    
    <a :href="`https://mui-kendal.or.id/pengurus/assets/files/upload/pdf/${newsDetail.image0}`" download class="text-decoration-none flex items-center px-4 py-2 text-sm text-green bg-blue-600 rounded-md shadow-md hover:bg-blue-700 transition-all duration-300" target="_blank">Download Khutbah Bahasa Indonesia</a>
    <a :href="`https://mui-kendal.or.id/pengurus/assets/files/upload/pdf/${newsDetail.image1}`" download class="text-decoration-none flex items-center px-4 py-2 text-sm text-green bg-blue-600 rounded-md shadow-md hover:bg-blue-700 transition-all duration-300" target="_blank">Download Khutbah Bahasa Jawa</a>
    <small class="text-muted">{{ newsDetail.create_at }}</small>
    <br />
    <!-- <router-link to="/" class="btn btn-primary mt-3">Kembali ke Daftar Berita</router-link> -->
  </div>
</template>

<script>
import axios from "axios";
export default {
  props: ["id"],
  data() {
    return {
      newsDetail: [],
      loading: true,
      error: null,
    };
  },
  methods: {
    async fetchNews() {
      try {
        const response = await axios.get(`https://mui-kendal.or.id/pengurus/Api/bacakhutbah/${this.id}`);
        this.newsDetail = response.data[0];
        
      } catch (err) {
        this.error = "Gagal memuat berita. Coba lagi nanti.";
      } finally {
        this.loading = false;
      }
    },
    formatDate(date) {
      const options = { year: "numeric", month: "long", day: "numeric" };
      return new Date(date).toLocaleDateString("id-ID", options);
    },
  },
  created() {
    this.fetchNews();
  },
};
</script>
 